import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { constructArtificialLinkNode, getStaticPageLink } from "../../../../utils/links";
import LinkWrapper from "../../linkWrapper/LinkWrapper";
import Image from "../../image/Image";

const Logo = ({ logoClass, brand }) => {
    return (
        <div className={`${logoClass ? logoClass : ""}`}>
            {brand.logo && (
                <LinkWrapper linkNode={constructArtificialLinkNode({ value: getStaticPageLink("HOME") })}>
                    <Image imageNode={brand.logo} className="logo-img" />
                </LinkWrapper>
            )}
        </div>
    );
};

Logo.propTypes = {
    logoClass: PropTypes.string,
};

const mapStateToProps = (state) => ({
    brand: state.brandData,
});

export default connect(mapStateToProps)(Logo);
